import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77125586"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "ticketDetail",
  ref: "ticketDetail"
}
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-upload-text" }, "上传", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["src"]
const _hoisted_7 = { style: {"font-size":".14rem","color":"#ff0000aa"} }
const _hoisted_8 = { style: {"font-size":".14rem","color":"#ff0000aa"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!
  const _component_Item = _resolveComponent("Item")!
  const _component_Col = _resolveComponent("Col")!
  const _component_Option = _resolveComponent("Option")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Row = _resolveComponent("Row")!
  const _component_TextArea = _resolveComponent("TextArea")!
  const _component_Upload = _resolveComponent("Upload")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_TreeSelect = _resolveComponent("TreeSelect")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_ConfigProvider = _resolveComponent("ConfigProvider")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Modal, {
      getContainer: () => _ctx.$refs.ticketDetail,
      title: _ctx.titles,
      placement: "right",
      width: '9rem',
      centered: "",
      visible: _ctx.ticketModalVisible,
      okText: "指派",
      onOk: _ctx.handleTicketOK,
      onCancel: _ctx.handleCloseModal,
      maskClosable: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Form, {
            ref: "formRef",
            model: _ctx.formState,
            rules: _ctx.rules,
            "label-col": _ctx.labelCol,
            "wrapper-col": _ctx.wrapperCol
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Row, { align: 'top' }, {
                default: _withCtx(() => [
                  _createVNode(_component_Col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Item, {
                        ref: "title",
                        label: "工单标题",
                        name: "title"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Input, {
                            class: "title-input",
                            placeholder: "请输入标题",
                            value: _ctx.formState.title,
                            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.title) = $event))
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }, 512)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Item, {
                        label: "工单类型",
                        name: "type"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Select, {
                            style: {"text-align":"left"},
                            value: _ctx.formState.type,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.type) = $event)),
                            placeholder: "请选择工单类型"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.grantTicktTypeList, (cur) => {
                                return (_openBlock(), _createBlock(_component_Option, {
                                  key: cur.key,
                                  value: cur.key
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(cur.label), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_Row, { align: 'top' }, {
                default: _withCtx(() => [
                  _createVNode(_component_Col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Item, {
                        ref: "address",
                        label: "详细地址",
                        name: "address",
                        "label-col": _ctx.itemLabelCol,
                        "wrapper-col": _ctx.itemWrapperCol
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Select, {
                            style: {"text-align":"left"},
                            value: _ctx.formState.address,
                            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.address) = $event)),
                            "show-search": "",
                            placeholder: "请输入搜索地址",
                            "default-active-first-option": false,
                            "show-arrow": false,
                            "filter-option": false,
                            "not-found-content": null,
                            options: _ctx.addressList,
                            onSearch: _ctx.addressSearch,
                            onChange: _ctx.addressChange
                          }, null, 8, ["value", "options", "onSearch", "onChange"])
                        ]),
                        _: 1
                      }, 8, ["label-col", "wrapper-col"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_Row, { align: 'top' }, {
                default: _withCtx(() => [
                  _createVNode(_component_Col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Item, {
                        label: "工单描述",
                        name: "describetion",
                        "label-col": _ctx.itemLabelCol,
                        "wrapper-col": _ctx.itemWrapperCol
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_TextArea, {
                            placeholder: "请输入工单描述内容，不超过200字",
                            value: _ctx.formState.describetion,
                            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.describetion) = $event)),
                            rows: 5
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }, 8, ["label-col", "wrapper-col"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_Row, { align: 'top' }, {
                default: _withCtx(() => [
                  _createVNode(_component_Col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Item, {
                        label: "上传照片",
                        "label-col": _ctx.itemLabelCol,
                        "wrapper-col": _ctx.itemWrapperCol
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Upload, {
                            action: `${_ctx.serverIp}/file/upLoadFile`,
                            "list-type": "picture-card",
                            "file-list": _ctx.fileList,
                            onPreview: _ctx.handlePreview,
                            onChange: _ctx.handleChange,
                            accept: ".jpg,.jpeg,.gif,.png"
                          }, {
                            default: _withCtx(() => [
                              (_ctx.fileList.length < 9)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }, 8, ["action", "file-list", "onPreview", "onChange"]),
                          _createVNode(_component_Modal, {
                            visible: _ctx.previewVisible,
                            footer: null,
                            onCancel: _cache[4] || (_cache[4] = ($event: any) => (_ctx.previewVisible = false))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("img", {
                                alt: "example",
                                style: {"width":"100%"},
                                src: _ctx.previewImage
                              }, null, 8, _hoisted_6)
                            ]),
                            _: 1
                          }, 8, ["visible"])
                        ]),
                        _: 1
                      }, 8, ["label-col", "wrapper-col"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _withDirectives(_createVNode(_component_Row, { align: 'top' }, {
                default: _withCtx(() => [
                  _createVNode(_component_Col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Item, {
                        label: "处理单位",
                        name: "unit"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_TreeSelect, {
                            value: _ctx.formState.unit,
                            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formState.unit) = $event)),
                            placeholder: "请选择处理单位",
                            "show-search": "",
                            style: {"text-align":"left"},
                            "dropdown-style": { maxHeight: '200px', overflow: 'auto' },
                            "allow-clear": "",
                            "tree-default-expand-all": "",
                            onChange: _ctx.changeCompany,
                            treeData: _ctx.companyList
                          }, null, 8, ["value", "onChange", "treeData"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Item, {
                        label: "处理人",
                        name: "person"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Select, {
                            disabled: !_ctx.userListById.length,
                            style: {"text-align":"left"},
                            value: _ctx.formState.person,
                            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formState.person) = $event)),
                            placeholder: "请选择处理人"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userListById, (cur) => {
                                return (_openBlock(), _createBlock(_component_Option, {
                                  key: cur.id,
                                  value: cur.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(cur.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["disabled", "value"]),
                          _withDirectives(_createElementVNode("span", _hoisted_7, " 当前处理单位无处理人，请更换处理单位 ", 512), [
                            [_vShow, !_ctx.userListById.length]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512), [
                [_vShow, _ctx.userInfo.dataType !== 'personalData']
              ]),
              _createVNode(_component_Row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Item, {
                        label: "抄送人",
                        name: "duplicateId",
                        labelCol: { span: 6 }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Select, {
                            disabled: !_ctx.duplicateOptions.length,
                            style: {"text-align":"left"},
                            value: _ctx.formState.duplicateId,
                            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formState.duplicateId) = $event)),
                            placeholder: "请选择抄送人",
                            mode: "multiple"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.duplicateOptions, (cur) => {
                                return (_openBlock(), _createBlock(_component_Option, {
                                  key: cur.value,
                                  value: cur.value,
                                  disabled: cur.disabled
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(cur.label), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value", "disabled"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["disabled", "value"]),
                          _withDirectives(_createElementVNode("span", _hoisted_8, " 当前处理单位无抄送人，请更换处理单位 ", 512), [
                            [_vShow, !_ctx.duplicateOptions.length]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Item, {
                        ref: "handleTimeLimit",
                        label: "完成时间",
                        name: "handleTimeLimit"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ConfigProvider, { locale: _ctx.zhCN }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DatePicker, {
                                value: _ctx.formState.handleTimeLimit,
                                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formState.handleTimeLimit) = $event)),
                                disabledDate: _ctx.disabledDate,
                                disabled: !_ctx.userListById.length,
                                format: "YYYY-MM-DD HH:mm:ss",
                                "show-time": { format: 'HH:mm:ss' },
                                placeholder: "请选择完成时间"
                              }, null, 8, ["value", "disabledDate", "disabled"])
                            ]),
                            _: 1
                          }, 8, ["locale"])
                        ]),
                        _: 1
                      }, 512)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules", "label-col", "wrapper-col"])
        ])
      ]),
      _: 1
    }, 8, ["getContainer", "title", "visible", "onOk", "onCancel"])
  ], 512))
}